// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__3Mrby","content":"Layout_content__2H50A"};